/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

/* eslint-disable max-len */
import { ISlsServiceEndpointsSearchServiceRepository } from '../interfaces/ISlsServiceEndpointsSearchServiceRepository';
import { SlsServiceEndpointsSearchServiceRepositoryImpl } from '../impls/SlsServiceEndpointsSearchServiceRepositoryImpl';

export class SlsServiceEndpointsSearchService
    implements ISlsServiceEndpointsSearchServiceRepository
{
    private oSlsServiceEndpointServiceRepository: SlsServiceEndpointsSearchServiceRepositoryImpl;

    constructor(basePath: string) {
        this.oSlsServiceEndpointServiceRepository =
            new SlsServiceEndpointsSearchServiceRepositoryImpl(basePath);
    }

    async fetchSlsServiceEndpoints(): Promise<{ [key: string]: string }> {
        return this.oSlsServiceEndpointServiceRepository.fetchSlsServiceEndpoints();
    }
}
